const ArticleTypes = {
    NORMAL: "0",
    GALLERY: "1"
}
export default ArticleTypes;